export const categories = [
  { slug: "dianying", name: "电影", icon: "ri-movie-2-line", description: "热门电影高清在线观看，涵盖动作、喜剧、科幻、爱情等多种类型" },
  { slug: "dianshiju", name: "电视剧", icon: "ri-tv-2-line", description: "最新电视剧全集免费看，国产剧、韩剧、美剧一网打尽" },
  { slug: "zongyi", name: "综艺", icon: "ri-emotion-laugh-line", description: "热门综艺节目在线观看，搞笑、选秀、真人秀精彩不断" },
  { slug: "dongman", name: "动漫", icon: "ri-ghost-line", description: "热门动漫在线播放，日漫、国漫、剧场版高清不卡顿" },
  { slug: "jilupian", name: "纪录片", icon: "ri-earth-line", description: "精选纪录片合集，自然、历史、科技、人文应有尽有" },
  { slug: "tiyu", name: "体育", icon: "ri-basketball-line", description: "体育赛事精彩回放，足球、篮球、电竞等赛事全覆盖" },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((c) => { categoryMap[c.slug] = c; });